import {
  ArrowRightSolid,
  SquareSolid,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  generating: boolean
  active: boolean
  disabled: boolean
  handleSubmitClick: () => void
}

export const SubmitButton: React.FC<Props> = ({
  generating,
  active,
  disabled,
  handleSubmitClick,
}) => (
  <div
    className={clsJoin(
      css.ai_chat_sidebar_submit,
      active && css.active,
      disabled && css.disabled
    )}
    onClick={handleSubmitClick}
  >
    {generating ? (
      <SquareSolid className={css.icon} />
    ) : (
      <ArrowRightSolid className={css.icon} />
    )}
  </div>
)
